import { Injectable } from '@angular/core';

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: November 14th 2017
 * 
 * Description: Provide service methods for Top Navigation Data.
 **/
@Injectable()
export class TopnavService {

    flagLang: any;
    flagLangAppMngmnt: any = false;
    navKeyword: any;
    flagLangApp: any = false;

  getUserMenu(){
        return USERMENU;
    }

    getColors(){
        return COLORS;
    }

    getFonts(){
        return FONTS;
    }

  constructor() { }

  getEventLang(){
    this.flagLang = true;
    
  }

  getNavKeyWord() {
    return this.navKeyword;
  }

  //for app - managemnet purposes
  getFlagLang(a){
    this.flagLangAppMngmnt = a;
    //console.log('test', this.flagLangAppMngmnt);
    return this.flagLangAppMngmnt;
  }

  getFlagLangApp(a){
    this.flagLangApp = a;
    //console.log('test', this.flagLangApp);
    return this.flagLangApp;
  }
}
const USERMENU = [{
        id: 1,
        name: 'My Profile',
        url: ''
    },
    {
        id: 2,
        name: 'InBox',
        url: ''
    }
];

const COLORS = [
    {
        bgColor: '#00bdbb'
    }, {
        bgColor: '#5e7899'
    },
    {
        bgColor: '#e06000'
    },
    {
        bgColor: '#4f81c5'
    },
     {   bgColor: '#982d57'
    }
    ];

const FONTS = [
        'Roboto',
        'Arial',
        'Times New Roman'
    ];



// WEBPACK FOOTER //
// ./src/app/header/topnav/topnav.service.ts